import React, { Component } from "react";
import * as actionCreators from '../../../modules/actions/index';
import {UserRole} from '../../../utils/constants';
import { Row, Col, Popover, PopoverHeader, PopoverBody} from 'reactstrap';
import * as Url from '../../../utils/url';
import axios from '../../../axios';
import { connect } from 'react-redux';
import Tooltip from '../../../components/UI/TooltipIcon/TooptipIcon';
import EditOfficeModal from './EditOfficeModal/EditOfficeModal';
import Loading from '../../../hoc/Loading/Loading';
import sortBy from 'lodash/sortBy';
import './OfficeInformation.css';

class OfficeInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
        officeDetails: {},
        officeFunctions: [],
        productTypes: [],
        customerTypes: [],
        showEditOfficeInfoModal: false,
        officeSizePopoverOpen: false
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const unblock = this.props.history.block((location, action) => {
        let {showEditOfficeInfoModal} =  this.state;
        if (showEditOfficeInfoModal) return "You have not completed the process yet. Are you sure you want to leave without completing it?";
      }); 
    const unlisten = this.props.history.listen((location, action) => {
        if (location.pathname !== `/home/office-info` || action!=='PUSH' ) {
          unlisten();
          unblock();
        }
      })  

    this.getOfficeInformation(this.props.user.officeId._id);
    this.getOccupationCustomerProductList();
  }

  handleOfficeUpdateSuccess = (data) => {
    // this.props.onProfileUpdate(data);
  }

  getOfficeInformation = (officeId) => {
    axios.get(Url.fetchOfficeDetails(officeId)).then((response) => {
        this.setState({ officeDetails: response.data.data });
        let office = this.state.officeDetails
        let name = office.displayName
        this.props.onProfileUpdate({officeName:name})
    }).catch((error) => {
        console.log(error);
    })
  }

  getOccupationCustomerProductList = () => {
    axios.get(Url.getOccupationCustomerProductList).then((response) => {
        // console.log(response.data);
        let officeFunctions = [], productTypes = [], customerTypes = [];
        for(let category of response.data.data) {
            if(category._id === 'PRODUCT'){
                productTypes = category.docs.map((doc) => {
                    return {_id: doc._id, name: doc.name}
                });
            } else if (category._id === 'CUSTOMER') {
                customerTypes = category.docs.map((doc) => {
                    return {_id: doc._id, name: doc.name}
                });
            } else if (category._id === 'OCCUPATION') {
                officeFunctions = category.docs.map((doc) => {
                    return {_id: doc._id, name: doc.name}
                });
            }
        }
        officeFunctions = sortBy(officeFunctions, ['name']);
        productTypes = sortBy(productTypes, ['name']);
        customerTypes = sortBy(customerTypes, ['name']);
        this.setState({officeFunctions, productTypes, customerTypes});
    }).catch((error) => {
        console.log(error);
    })
  }

  toggleOfficeSizePopover = () => {
      this.setState({officeSizePopoverOpen: !this.state.officeSizePopoverOpen});
  }

  render() {
    let {role} = {...this.props.user};
    let {officeSizePopoverOpen, officeDetails, showEditOfficeInfoModal, officeFunctions, productTypes, customerTypes } = this.state;
    let {name, displayName, address, organizationId, occupation, productType, customerType, officeSize} = officeDetails;  
      return (<div className="mb40 mt70">
          <Row className="mlmr0">
              <span className="office-info-title">Office Profile</span>
          </Row>
          <div className="mt10 office-info-hr"></div>
          <Row className="row mt40">
              <Col sm={3} className="text-right">
                  <span className="office-info-label">Office Name</span>
              </Col>
              <Col sm={9} className="align-self-center">
                  <span className="office-info-value">{name}</span>
              </Col>
          </Row>
          <Row className="row mt20">
              <Col sm={3} className="text-right">
                  <span className="office-info-label">Industry</span>
              </Col>
              <Col sm={9} className="align-self-center">
                  <span className="office-info-value">{(organizationId && organizationId.industry) ? organizationId.industry.name : '' }</span>
              </Col>
          </Row>
          <Row className="row mt20">
              <Col sm={3} className="text-right">
                  <span className="office-info-label">Office Display Name</span>
              </Col>
              <Col sm={9} className="align-self-center">
                  <span className="office-info-value">{displayName ? displayName : 'n/a'}</span>
              </Col>
          </Row>
          <Row className="row mt20">
              <Col sm={3} className="text-right">
                  <span className="office-info-label">Function</span>
              </Col>
              <Col sm={9} className="align-self-center">
                  <span className="office-info-value">{(occupation && occupation.name ) ? occupation.name: 'n/a'}</span>
              </Col>
          </Row>
          <Row className="row mt20">
              <Col sm={3} className="text-right">
                  <span className="office-info-label">Product Type</span>
              </Col>
              <Col sm={9} className="align-self-center">
                  <span className="office-info-value">{(productType && productType.name ) ? productType.name: 'n/a'}</span>
              </Col>
          </Row>
          <Row className="row mt20">
              <Col sm={3} className="text-right">
                  <span className="office-info-label">Customer Type</span>
              </Col>
              <Col sm={9} className="align-self-center">
                  <span className="office-info-value">{(customerType && customerType.name ) ? customerType.name: 'n/a'}</span>
              </Col>
          </Row>
          <Row className="row mt20">
              <Col sm={3} className="text-right">
                  <span className="office-info-label">Location</span>
              </Col>
              <Col sm={9} className="align-self-center">
                  <span className="office-info-value">{address ? address.fullAddress : 'n/a'}</span>
              </Col>
          </Row>
          {(role === UserRole.admin) ? <div className="row mt20">
          <Col sm={{ size: 9, offset: 3 }} className="align-self-center">
            <a className="edit-profile-info-link" onClick={() => {
                                    this.setState((state) =>
                                        ({ showEditOfficeInfoModal: !state.showEditOfficeInfoModal}))
                                }}>Edit Office Information</a>
          </Col>
        </div>: null}
          {/* <Row className="row mt40">
              <Col sm={3} className="d-flex justify-content-end align-items-center">
               {(role === UserRole.admin) ? <span><span id="office-size-popover" className="d-flex mr10" onClick={this.toggleOfficeSizePopover}><Tooltip /></span>
                <Popover placement="left" isOpen={officeSizePopoverOpen} target="office-size-popover" toggle={this.toggleOfficeSizePopover}>
                    <PopoverHeader className="popover-header-tooltip">Office Size</PopoverHeader>
                      <PopoverBody className="popover-body-tooltip">Office size reflects number of employees in your office and is automatically calculated from the available employee data. To change it, you can upload new employee data.</PopoverBody>
                    </Popover></span> : null }             
                <span className="office-info-label">Office Size</span>
              </Col>
              <Col sm={9} className="align-self-center">
                  <span className="office-info-value">{officeSize ? officeSize: 'n/a'}</span>
              </Col>
          </Row> */}
          {showEditOfficeInfoModal && <EditOfficeModal
              showEditOfficeInfoModal={showEditOfficeInfoModal}
              officeDetails={officeDetails}
              officeFunctions={officeFunctions}
              productTypes={productTypes}
              customerTypes={customerTypes}
              user={this.props.user}
              editSuccess={() => {
                this.setState((state) =>
                    ({ showEditOfficeInfoModal: !state.showEditOfficeInfoModal }));
                    this.getOfficeInformation(this.props.user.officeId._id);      
                }}
              closeModal={() => {
                  this.setState((state) =>
                      ({ showEditOfficeInfoModal: !state.showEditOfficeInfoModal }))
              }}
          />}
      </div>);
  }
}

const mapStateToProps = state => {
	return {
     user: state.user.profile,
	}
}


const mapDispatchToProps = dispatch => {
	return {
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Loading(OfficeInformation, axios));